import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_7.mp3"
export default function P1() {
    return (
        <MainLayout
            title="A daleko do tego Tarszewa?"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p14,
            }}
            content={
                <div>
                    <ul>
                        <li>A daleko do tego Tarszewa?</li>
                        <li>Do Tarszewa? Na piechotę kawałek i buty można przemoczyć na łąkach… A w niejednej rodzinie w tych stronach buty się na spółkę nosi! Ale my pojedziemy wozem, prosto z knajpy Łukaszewskiego! Po drodze zobaczysz nasze łąki, a na nich stada słynnych, zagórowskich gęsi! – rozgaduje się Emil. – Mamy ich tu tysiące! W środę jest targ w miasteczku, zobaczysz, jak wyglądają jarmarki w Zagórowie. Pomóż mi, a wszystko ci pokażę! – w jego oczach widzisz nadzieję tak dużą, że nie potrafisz odmówić.</li>
                        <li>Za mną długie kilometry, więc ani kolacji, ani noclegu nie odmówię! I ze śliwkami pomogę.</li>
                        <li>Dziękuję, jestem Twoim dłużnikiem! – krzyczy z radości. – Emil jestem, miło mi!</li>
                    </ul>
                </div>
            }
        />

    );
}